import { lottiesPaths } from 'Constants/lottiesPaths';
import Lottie from '../Lottie';
import * as Styled from './styles';

const SplashLoader = (): JSX.Element => (
  <Styled.LoaderContainer justify="center" align="center">
    <Styled.LottieContainer>
      <Lottie options={{ path: lottiesPaths.SPLASH_SCREEN }} />
    </Styled.LottieContainer>
  </Styled.LoaderContainer>
);

export default SplashLoader;
